import { render, staticRenderFns } from "./RevisarCotizacionView.vue?vue&type=template&id=6d52606e&scoped=true&lang=pug"
import script from "./RevisarCotizacionView.vue?vue&type=script&lang=js"
export * from "./RevisarCotizacionView.vue?vue&type=script&lang=js"
import style0 from "./RevisarCotizacionView.vue?vue&type=style&index=0&id=6d52606e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52606e",
  null
  
)

export default component.exports